/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: #CEFF00;
  }
`
export default class ChangeBtnIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" css={Color}><g transform="translate(-411.88 -1837)"><rect width="46" height="46" transform="translate(411.88 1837)" fill="#fff" opacity="0" /><path d="M54.768,24.61a15.776,15.776,0,0,1,.659-6.957C57.789,10.433,65.2,5.124,73.992,5.03V.311c0-.262.366-.4.606-.243L85.439,7.2a.28.28,0,0,1,0,.478l-10.83,7.135c-.251.159-.606.019-.606-.243V9.862a14.268,14.268,0,0,0-12.837,7.791,11.4,11.4,0,0,0-1.1,5.562,11.929,11.929,0,0,0,3.094,7.238,2.258,2.258,0,0,1-.512,3.465,2.938,2.938,0,0,1-3.742-.468A16.428,16.428,0,0,1,54.768,24.61Zm31.3-9.064a11.786,11.786,0,0,1,3.094,7.238,11.472,11.472,0,0,1-1.1,5.562,14.252,14.252,0,0,1-12.837,7.791v-4.71c0-.262-.366-.4-.606-.243l-10.84,7.135a.281.281,0,0,0,0,.478l10.83,7.135c.251.159.606.019.606-.243V40.969c8.791-.084,16.213-5.394,18.565-12.623a15.93,15.93,0,0,0,.659-6.957,16.339,16.339,0,0,0-4.129-8.84,2.939,2.939,0,0,0-3.742-.468A2.263,2.263,0,0,0,86.066,15.546Z" transform="translate(360.242 1837.001)" fill="#ceff00" /></g></svg>
      </Fragment>
    )
  }
}
